import { bindable, BindingMode, watch } from "aurelia"
import { IFormInputOption } from "../interfaces/form-interface"

export class TypeaheadSelectChipComponent {
  @bindable private label: string
  @bindable({ mode: BindingMode.twoWay }) private typeaheadOptions: IFormInputOption[] = []
  @bindable({ mode: BindingMode.twoWay }) private chipOptions: IFormInputOption[] = []
  @bindable private helper: string
  @bindable searchFunction: (query: string) => Promise<IFormInputOption[]>;
  @bindable({ mode: BindingMode.twoWay }) private selectedOption: IFormInputOption
  private selectedTypeaheadOption: IFormInputOption
  private selectedTypeaheadOptionValue: string

  selectChipOption(option: IFormInputOption) {
    this.selectedTypeaheadOption = null
    this.selectedTypeaheadOptionValue = null
    this.selectedOption = option
  }

  @watch('selectedTypeaheadOption')
  handleSelectedTypeaheadOption() {
    if (!this.selectedTypeaheadOption) return

    if (this.selectedOption?.value == this.selectedTypeaheadOption?.value) return

    this.selectedOption = this.selectedTypeaheadOption
  }

  @watch('selectedOption')
  handleSelectedOption() {
    if (this.typeaheadOptions.includes(this.selectedOption)) {
      this.selectedTypeaheadOptionValue = this.selectedOption.label
      this.selectedTypeaheadOption = this.selectedOption
    }
  }
}